<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-12">
        <router-link
          to="/profile/setting/two-step-verification"
          class="btn btn-light btn-sm rounded"
          ><i class="fas fa-arrow-left text-white mt-1"></i>
          <span class="btn btn-sm text-white">
            {{ $t("verification.back") }}</span
          >
        </router-link>
      </div>
    </div>
    <div v-if="!loading_user">
      <div>
        <div class="row justify-content-center mt-2">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-6">
                    <p>
                      {{ $t("verification.instead-of-waiting") }}
                    </p>
                    <br />
                    <p>
                      {{ $t("verification.first-download") }}
                    </p>

                    <p v-if="!authenticator">
                      <b-button
                        class="btn text-white mt-3"
                        variant="secondary"
                        @click="modalSetup"
                      >
                        <i class="fas fa-plus text-white mr-2"></i>
                        <span class="text-white">
                          {{ $t("verification.set-up") }}
                        </span></b-button
                      >
                    </p>

                    <div class="card border p-3" v-else>
                      <span>{{ $t("verification.your-authenticator") }}</span>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-2 text-center">
                            <i class="bx bx bx-lock bx-lg"></i>
                          </div>
                          <div class="col-8">
                            <span> {{ $t("verification.authenticator") }}</span>
                            <br />
                            <span> {{ user_profile.last_update_2fa }}</span>
                            <br />
                            <br />
                            <a
                              href="#"
                              @click="modalSetupChange"
                              class="text-success"
                              >{{ $t("verification.change-autentikator") }}</a
                            >
                          </div>
                          <div class="col-2 text-right hoverable">
                            <i
                              class="bx bx-trash bx-sm"
                              @click="modalDeleteAuth"
                            ></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 text-right">
                    <img
                      src="https://www.gstatic.com/identity/accountsettings/strongauth/authenticator_app_light_8c17a68c1a4d2b992c7260041765b66d.svg"
                      alt="qr"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="row mt-lg-2">
        <div class="col-12 text-center">
          <div class="card">
            <div class="card-body p-5">
              <b-spinner
                v-if="loading_user"
                label="Loading ..."
                small
              ></b-spinner>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-setup-auth"
      centered
      :title="this.$t('verification.set-up-auth')"
      title-class="font-16"
      hide-footer
    >
      <div class="">
        <div v-if="tab == 'tab_info'" class="row">
          <div class="col-12 p-3 mb-5 pb-5">
            <p>1. {{ $t("verification.in-the-google-authenticator") }}</p>
            <p>
              2. {{ $t("verification.enter-your-email-address") }} <br /><b
                class="ml-3"
                >{{ stringkey }}</b
              >
            </p>
            <p>3. {{ $t("verification.make-sure-that") }}</p>
            <p>4. {{ $t("verification.tap-add") }}</p>
          </div>
        </div>
        <div v-else-if="tab == 'enter_code'" class="row">
          <div class="col-12 mb-1">
            <p>* {{ $t("verification.enter-the") }}</p>
          </div>
          <div class="col-12 p-3 mb-5 pb-5">
            <input
              type="text"
              class="form-control mb-1"
              :placeholder="this.$t('verification.enter-code')"
              v-model="code_otp"
              required
            />
            <span class="mt-2 text-danger" v-if="error_otp">{{
              error_otp
            }}</span>
          </div>
        </div>

        <div v-else class="row">
          <div class="col-12 mb-3">
            <p>* {{ $t("verification.in-the-google") }}</p>
            <p>* {{ $t("verification.choose-scan") }}</p>
          </div>
          <div class="col-12 text-center p-3">
            <span class="p-5 m-5" v-if="loading_img">
              <b-spinner label="Loading ..." class="p-5 m-5" small></b-spinner>
            </span>
            <img :src="img_base64" alt="qr" class="rounded" v-else />
          </div>
          <div class="col-12 mt-4 text-center">
            <span class="text-center"
              ><button class="btn text-success" @click="tabInfo('tab_info')">
                {{ $t("verification.cant-scan-it") }}
              </button></span
            >
          </div>
        </div>

        <div class="col-md-12 mt-5">
          <div class="row">
            <div class="col-4">
              <b-button
                class="mt-3 mr-1"
                variant="light"
                v-if="tab == 'tab_info' || tab == 'enter_code'"
                @click="tabInfo('')"
                >{{ $t("verification.back") }}
              </b-button>
            </div>
            <div class="col-8 text-right">
              <div class="text-right">
                <b-button
                  class="mt-3 mr-1"
                  variant="light"
                  @click="hideModalSetup"
                  >{{ $t("verification.cancel") }}
                </b-button>
                <b-button
                  class="mt-3 mr-1"
                  @click="tabInfo('enter_code')"
                  variant="primary"
                  v-if="tab !== 'enter_code'"
                >
                  <b-spinner
                    v-if="loading"
                    label="Loading ..."
                    small
                  ></b-spinner>
                  <span v-if="!loading"> {{ $t("verification.next") }} </span>
                  <span v-if="loading"> {{ $t("verification.next") }} .. </span>
                </b-button>
                <b-button
                  class="mt-3 mr-1"
                  @click="verifyOTP()"
                  variant="primary"
                  v-else
                >
                  <b-spinner
                    v-if="loading_otp"
                    label="loading..."
                    small
                  ></b-spinner>
                  <span v-if="!loading_otp">
                    {{ $t("verification.verify") }}
                  </span>
                  <span v-if="loading_otp">
                    {{ $t("verification.verify") }} ..
                  </span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-setup-auth-change"
      centered
      :title="this.$t('verification.change-autentikator')"
      title-class="font-16"
      hide-footer
    >
      <div class="">
        <div v-if="tab == 'tab_info'" class="row">
          <div class="col-12 p-3 mb-5 pb-5">
            <p>1. {{ $t("verification.in-the-google-authenticator") }}</p>
            <p>
              2. {{ $t("verification.enter-your-email-address") }} <br /><b
                class="ml-3"
                >{{ stringkey_change }}</b
              >
            </p>
            <p>3. {{ $t("verification.make-sure-that") }}</p>
            <p>4. {{ $t("verification.tap-add") }}</p>
          </div>
        </div>
        <div v-else-if="tab == 'enter_code'" class="row">
          <div class="col-12 mb-1">
            <p>* {{ $t("verification.enter-the") }}</p>
          </div>
          <div class="col-12 p-3 mb-5 pb-5">
            <input
              type="text"
              class="form-control mb-1"
              :placeholder="this.$t('verification.enter-code')"
              v-model="code_otp"
              required
            />
            <span class="mt-2 text-danger" v-if="error_otp">{{
              error_otp
            }}</span>
          </div>
        </div>

        <div v-else class="row">
          <div class="col-12 mb-3">
            <p>* {{ $t("verification.in-the-google") }}</p>
            <p>* {{ $t("verification.choose-scan") }}</p>
          </div>
          <div class="col-12 text-center p-3">
            <span class="p-5 m-5" v-if="loading_img">
              <b-spinner label="Loading ..." class="p-5 m-5" small></b-spinner>
            </span>
            <img :src="img_base64_change" alt="qr" class="rounded" v-else />
          </div>
          <div class="col-12 mt-4 text-center">
            <span class="text-center"
              ><button class="btn text-success" @click="tabInfo('tab_info')">
                {{ $t("verification.cant-scan-it") }}
              </button></span
            >
          </div>
        </div>

        <div class="col-md-12 mt-5">
          <div class="row">
            <div class="col-4">
              <b-button
                class="mt-3 mr-1"
                variant="light"
                v-if="tab == 'tab_info' || tab == 'enter_code'"
                @click="tabInfo('')"
                >{{ $t("verification.back") }}
              </b-button>
            </div>
            <div class="col-8 text-right">
              <div class="text-right">
                <b-button
                  class="mt-3 mr-1"
                  variant="light"
                  @click="hideModalSetupChange"
                  >{{ $t("verification.cancel") }}
                </b-button>
                <b-button
                  class="mt-3 mr-1"
                  @click="tabInfo('enter_code')"
                  variant="primary"
                  v-if="tab !== 'enter_code'"
                >
                  <b-spinner
                    v-if="loading"
                    label="Loading ..."
                    small
                  ></b-spinner>
                  <span v-if="!loading"> {{ $t("verification.next") }} </span>
                  <span v-if="loading"> {{ $t("verification.next") }} .. </span>
                </b-button>
                <b-button
                  class="mt-3 mr-1"
                  @click="verifyOTPChange()"
                  variant="primary"
                  v-else
                >
                  <b-spinner
                    v-if="loading_otp"
                    label="loading..."
                    small
                  ></b-spinner>
                  <span v-if="!loading_otp">
                    {{ $t("verification.verify") }}
                  </span>
                  <span v-if="loading_otp">
                    {{ $t("verification.verify") }} ..
                  </span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-delete"
      centered
      :title="this.$t('verification.remove-authenticator')"
      title-class="font-16"
      @ok="deleteAuthapps()"
      hide-footer
    >
      <div class="row">
        <div class="col-12"></div>
        <div class="col-md-12 mt-3">
          <span>
            {{ $t("verification.you-wont") }}
          </span>
        </div>

        <div class="col-md-12 mt-2">
          <div class="text-right">
            <b-button class="mt-3 mr-1" variant="light" @click="hideModalDelete"
              >Cancel</b-button
            >
            <b-button
              class="mt-3 mr-1"
              @click="deleteAuthapps()"
              variant="primary"
            >
              <b-spinner
                v-if="loading_delete"
                label="Loading..."
                small
              ></b-spinner>
              <span v-if="!loading_delete"> OK </span>
              <span v-if="loading_delete"> OK.. </span>
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import UserService from "@/helpers/user.service";
import appConfig from "@/app.config";
import moment from "moment";
import Stat from "@/components/widgets/stat";
import { required } from "vuelidate/lib/validators";
import { userService } from "@/helpers/authservice/user.service";
import verificationService from "@/helpers/verification.service";
import { revenueChart } from "./data-profile";

export default {
  page: {
    title: "Profile",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Stat },
  data() {
    return {
      urlImage: process.env.VUE_APP_BASE_API_URL_AVATAR,
      email: this.$store.state.authBackend.user.email,
      two_step_verification: false,
      verification_code: "",
      title: this.$t("verification.authenticator-app"),
      authenticator: false,
      image_avatar: "",
      code_otp: "",
      img_base64: "",
      stringkey: "",
      img_base64_change: "",
      stringkey_change: "",
      error_otp: "",
      tab: "",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Profile",
          href: "/profile",
        },
        {
          text: this.$t("malware.setting"),
          href: "/profile/setting",
        },
        {
          text: this.$t("verification.two-step-verification"),
          href: "/profile/setting/two-step-verification",
        },
        {
          text: this.$t("verification.authenticator-app"),
          active: true,
        },
      ],
      loading_user: false,
      loading: false,
      loading_img: false,
      loading_password: false,
      loading_delete: false,
      loading_otp: false,
      user_profile: {
        id_user: "",
        username: "",
        email: "",
        name: "",
        role: "",
        avatar: "",
        last_login: "",
        created_at: "",
        updated_at: "",
        is_active_2fa: "",
        last_update_2fa: "",
      },
      submitted: false,
    };
  },

  mounted() {
    this.getUser();
  },
  methods: {
    getUser() {
      let ferr = 0;
      this.loading_user = true;
      UserService.profileUser()
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getUser();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            let val = response.data.data;
            this.user_profile.id_user = val.id_user;
            this.user_profile.username = val.username;
            this.user_profile.email = val.email;
            this.user_profile.name = val.name;
            this.user_profile.role = val.role ?? "-";
            this.user_profile.avatar = val.avatar ?? "";
            this.user_profile.last_login = val.last_login ?? "-";
            this.user_profile.is_active_2fa = val.is_active_2fa;
            this.user_profile.last_update_2fa = this.formatDate(
              val.last_update_2fa
            );
            this.user_profile.created_at = this.formatDate(val.created_at);
            this.user_profile.updated_at = this.formatDate(val.updated_at);
            this.user_profile.tfa = val.tfa;

            console.log("type", val.tfa.type);
            if (val.tfa.type == "auth_app") {
              this.authenticator = true;
            }

            this.two_step_verification = val.is_active_2fa;
            this.loading_user = false;
            ferr = 1;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getUser();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading_user = false;
            }
          }
        });
    },

    setupAuth() {
      this.loading_img = true;
      let ferr = 0;
      const data = {
        token: localStorage.getItem("tfa_key"),
      };
      verificationService
        .setupAuth(data)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.setupAuth();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            let img = response.data.data.base64image;
            let string = response.data.data.stringkey;
            this.img_base64 = img;
            this.stringkey = string;
            // console.log('key', img);
            this.loading_img = false;
            ferr = 1;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.setupAuth();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading_img = false;
            }
          }
        });
    },

    setupAuthChange() {
      this.loading_img = true;
      let ferr = 0;
      const data = {
        token: localStorage.getItem("tfa_key"),
      };
      console.log("change");
      verificationService
        .setupAuthChanges(data)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.setupAuthChange();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            let img = response.data.data.base64image;
            let string = response.data.data.stringkey;
            this.img_base64_change = img;
            this.stringkey_change = string;
            // console.log('key', img);
            this.loading_img = false;
            ferr = 1;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.setupAuthChange();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading_img = false;
            }
          }
        });
    },

    verifyOTP() {
      let ferr = 0;
      this.error_otp = "";
      this.submitted = true;
      if (this.code_otp == "") {
        console.log("required");
        this.error_otp = "Code is required!";
      } else {
        this.loading_otp = true;
        const data = {
          token: localStorage.getItem("tfa_key"),
          otp: this.code_otp,
        };
        verificationService
          .verifyOTP(data)
          .then((response) => {
            if (response.status == 201) {
              let new_token = response.data.refresh_access_token;
              userService.splitToken(new_token);
              this.verifyOtp();
              ferr = 1;
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              let res = response;
              this.authenticator = true;
              this.code_otp = "";
              this.error_otp = "";
              (this.tab = ""), this.hideModalSetup();
              console.log("res", res);
              this.loading_otp = false;
              ferr = 1;
            }
          })
          .catch((err) => {
            // console.log('err', err.response.data.errors.message);
            // if (err.response) {
            //   }

            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.verifyOtp();
            } else {
              if (err.response.status == 401) {
                userService.logout();
              } else {
                console.log(err);
                this.error_otp = err.response.data.errors.message;
                this.loading_otp = false;
              }
            }
          });
      }
    },

    verifyOTPChange() {
      let ferr = 0;
      this.error_otp = "";
      this.submitted = true;
      if (this.code_otp == "") {
        console.log("required");
        this.error_otp = "Code is required!";
      } else {
        this.loading_otp = true;
        const data = {
          token: localStorage.getItem("tfa_key"),
          otp: this.code_otp,
        };
        verificationService
          .verifyOTPChanges(data)
          .then((response) => {
            if (response.status == 201) {
              let new_token = response.data.refresh_access_token;
              userService.splitToken(new_token);
              this.verifyOTPChange();
              ferr = 1;
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              let res = response;
              this.authenticator = true;
              this.code_otp = "";
              this.error_otp = "";
              (this.tab = ""), this.hideModalSetupChange();
              // console.log('res', res);
              this.loading_otp = false;
              ferr = 1;
            }
          })
          .catch((err) => {
            // console.log('err', err.response.data.errors.message);
            // if (err.response) {
            //   }

            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.verifyOTPChange();
            } else {
              if (err.response.status == 401) {
                userService.logout();
              } else {
                console.log(err);
                this.error_otp = err.response.data.errors.message;
                this.loading_otp = false;
              }
            }
          });
      }
    },

    modalSetup() {
      this.$bvModal.show("modal-setup-auth");
      this.setupAuth();
    },

    hideModalSetup() {
      this.$bvModal.hide("modal-setup-auth");
    },

    modalSetupChange() {
      this.$bvModal.show("modal-setup-auth-change");
      this.setupAuthChange();
    },

    hideModalSetupChange() {
      this.$bvModal.hide("modal-setup-auth-change");
    },

    modalDeleteAuth() {
      this.$bvModal.show("modal-delete");
    },

    hideModalDelete() {
      this.$bvModal.hide("modal-delete");
    },

    deleteAuthapps() {
      // console.log('delete auth app');
      this.loading_delete = true;
      let ferr = 0;
      const data = {
        token: localStorage.getItem("tfa_key"),
      };
      verificationService
        .deleteAuthapp(data)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.deleteAuthapps();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            // console.log('res', res);
            let res = response.data.data;
            this.hideModalDelete();
            this.getUser();
            this.authenticator = false;
            this.loading_delete = false;
            ferr = 1;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.deleteAuthapps();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading_delete = false;
            }
          }
        });
    },

    tabInfo(value) {
      this.tab = value;
    },

    // verifPassword(e){
    //   let ferr = 0;
    //   this.error_otp = '';
    //   this.submitted = true;
    //   this.$v.password.$touch();
    //   if(
    //     this.password == ""
    //   ) {
    //     e.preventDefault();
    //   } else {
    //   this.loading_password = true;
    //   const data = {
    //             "password" :  this.password,
    //           }
    //   verificationService.VerifPassword(data)
    //     .then((response) => {
    //       if (response.status == 201) {
    //         let new_token = response.data.refresh_access_token;
    //         userService.splitToken(new_token);
    //         this.verifPassword();
    //         ferr = 1;
    //       } else {
    //         let res = response;
    //         // console.log('res', res);
    //         if(this.type_modal_verif == 'turn_on'){
    //           this.setup2f();
    //         } else if(this.type_modal_verif == 'turn_off') {
    //           this.modalTurnOff();
    //         } else if(this.type_modal_verif == 'auth_app') {
    //           this.authenticator_app = true;
    //         }
    //         this.password = '';
    //         this.hideVerifPassword();
    //         this.loading_password = false;
    //         ferr = 1;
    //       }
    //     })
    //     .catch((err) => {
    //       // console.log('err', err.response.data.errors.message);
    //       if(err.response){
    //          this.error_otp = err.response.data.errors.message;
    //       }

    //       if (err.response == undefined) {
    //         console.log("err ->> ", err);
    //       } else if (ferr == 0 && err.response.status == 401) {
    //         this.verifPassword();
    //       } else {
    //         if (err.response.status == 401) {
    //           userService.logout();
    //         } else {
    //           console.log(err);
    //           this.loading_password = false;
    //         }
    //       }
    //     });
    //   }
    // },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },
  },
};
</script>
<style>
.hoverable:hover {
  cursor: pointer;
}
</style>
